export default __webpack_public_path__ + "static/media/lightsquare.77a2bcd6.svg";